interface FwStatusBadgeProps {
	status: string
}

export const FwStatusBadge = ({status}: FwStatusBadgeProps) => {
	const isIdle = status.toLowerCase() === "idle"
	return (
		<span
			className={`px-2 py-0.5 rounded-full text-xs font-medium ${
				isIdle
					? "text-green-600 bg-green-100 dark:text-green-300 dark:bg-green-900/40"
					: "text-yellow-600 bg-yellow-100 dark:text-yellow-300 dark:bg-yellow-900/40"
			}`}>
			{status}
		</span>
	)
}
